import { useEffect } from 'react';

export function syncBodyClassName(className, shouldHaveClass) {
  const body = document.querySelector('body');
  if (shouldHaveClass) {
    body.classList.add(className);
  } else {
    body.classList.remove(className);
  }
}

export default function useSyncedBodyClassName(className, shouldHaveClass) {
  useEffect(() => {
    syncBodyClassName(className, shouldHaveClass);
  }, [className, shouldHaveClass]);

  // On unmount, or if the classname changes, ensure the old classname is removed:
  useEffect(() => {
    return () => syncBodyClassName(className, false);
  }, [className]);
}
